import { breakSettings } from "@grindex-client/components/Slider/slider";
import CarouselLandingPageElements from "./carouselLandingPage.dom";

function init($views) {
	const $module = $views[0];
	const dom = new CarouselLandingPageElements($module);
	const $sliders = dom.sliderElements();

	$sliders.forEach(($slider) => {
		const upTime = $slider.dataset.pause;

		const slider = $($slider).bxSlider({
			auto: true,
			slideWidth: 208,
			minSlides: 1,
			maxSlides: 4,
			breaks: breakSettings.smallCardBreakSettings,
			pager: false,
			slideMargin: 20,
			pause: upTime ? upTime * 1000 : 5000,
			autoHover: true,
			autoReload: false,
			useCSS: false,
			moveSlides: 4,
		});

		var timeout = window.setTimeout(() => {
			slider.redrawSlider();
			clearTimeout(timeout);
		}, 500);
	});
}

export default {
	view: "carouselLandingPage",
	init,
};
